<mat-card>
    <mat-card-header class="titreFrm">
        <mat-card-title>{{nomFenetre.toUpperCase()}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>


         <form #frmEntetDocument="ngForm">
            <mat-card >
                <mat-card-content>
                    <div  class="display-flex-end">
                        <!-- <button (click)="goToListeDocument()" mat-raised-button class="colorGreen button-row">
                            <mat-icon>format_list_bulleted</mat-icon>
                            Liste {{nameBtn}}
                        </button> -->
                        <button *ngIf="!disabled" [disabled]="!exist || disabled" mat-raised-button class="colorGreen button-row">
                            <mat-icon>print</mat-icon>
                            Imprimer</button>
                        <button *ngIf="!disabled" [disabled]="!exist || disabled"(click)="enregistrer()" mat-raised-button class="colorGreen button-row">
                            <mat-icon>save</mat-icon>
                            Enregistrer
                        </button>
                    </div>
                    <div class="display-flex">
                        <!-------------------- entet document ------------------->
                        <div class="entetDocument">
                            <mat-form-field     appearance="outline" >
                                <mat-label>Référence</mat-label>
                                <input [disabled]="true" matInput name="Doc_Num" [(ngModel)]="document.Doc_Num" #Doc_Num="ngModel" placeholder="Référence" >
                            </mat-form-field>
                            <mat-form-field  style="width: 130px;"   appearance="outline" >
                                <mat-label>Date</mat-label>
                                <input [disabled]="disabled" matInput name="Doc_Date" [(ngModel)]="document.Doc_Date" #Doc_Date="ngModel" placeholder="Date" required [matDatepicker]="picker1">
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                            <!-- <mat-form-field     appearance="outline" >
                                <mat-label>Devise</mat-label>
                                <mat-select [disabled]="disabled" name="Doc_Devise_Cours" #Doc_Devise_Cours="ngModel" [(ngModel)]="document.Doc_Devise_Cours" placeholder="Devise" required>
                                    <mat-option *ngFor="let devise of listeDevise" [value]="devise.DiverSys_Index">
                                        {{devise.DiverSys_Titre}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field> -->
                            <mat-form-field   style="width: 250px;"   appearance="outline" >
                                <mat-label>Intitulé</mat-label>
                                <input [disabled]="disabled" matInput name="Doc_Obs" #Doc_Obs="ngModel" [(ngModel)]="document.Doc_Obs" placeholder="Intitulé" required >
                            </mat-form-field>
                            <mat-form-field  style="width: 75px;" appearance="outline">
                                <mat-label>TVA</mat-label>
                                <mat-select placeholder="TVA" [disabled]="disabled" name="tva" [(ngModel)]="tva" #tvaa="ngModel" (selectionChange)="onTvaChange()">
                                <mat-option *ngFor="let t of listeTva" [value]="t.DiverSys_Index">
                                    {{t.DiverSys_Titre}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span *ngIf="fenetre == '5'" >
                                <button *ngIf="!disabled" [disabled]="!exist || disabled" (click)="attacherDocument()" mat-raised-button class="colorGreen">
                                    <mat-icon>mouse</mat-icon>
                                    Choisir une facture
                                </button>&nbsp;
                                <span *ngIf="factureAvoir">
                                    <b>Facture N° </b>{{factureAvoir.Document[0].Doc_Num}} 
                                    <b>Client </b>{{factureAvoir.Document[0].Doc_RS}} 
                                </span>
                            </span>
                        </div>
                        <!-------------------- fin entet document ------------------->

                    </div>
                </mat-card-content>
            </mat-card>
        </form>
        <mat-tab-group #tabGroupe [selectedIndex]="index" (selectedIndexChange)="index=($event)" (animationDone)="animationDone()">
            <!-------------------- Informations client ------------>

            <mat-tab label="Informations client">
                <form class="example-form" #frmInformationclient="ngForm">
                    <input id="sendBtn" type="submit" (click)="doNotThink()" style="display: none;" value="send">
                    <mat-card >
                        <mat-card-content>
                            <div class="center">
                                <div class="informationsClient">
                                    <!-- client -->
                                    <app-recherche
                                        #clientComponent
                                        [disabled]="disabled"
                                        [numColonneToShow]="1"
                                        [required]="true"
                                        [style]="{'width':'450px'}"
                                        (ChampEnter)="blurTiers($event)"
                                        [name]="'sname_1'"
                                        [api]="generalService.api" ngModel
                                        recherche="TierType" [param]="'1'" placeholder="Client" >
                                    </app-recherche>

                                    <!-- Informations -->
                                    <span>
                                        <mat-form-field     appearance="outline"  class="large-width">
                                            <mat-label>Client à facturer</mat-label>
                                            <input [disabled]="disabled" matInput name="info" [(ngModel)]="tiersEntiteFacturation.Tiers_NomPublic" #Tiers_NomPublic="ngModel" placeholder="Informations" >
                                        </mat-form-field>
                                        <mat-checkbox [(ngModel)]="showInformationsInPrint" name="show_Informations_In_Print">Ne pas faire apparaître sur le devis</mat-checkbox>
                                    </span>

                                    <!-- Adresse 1 -->
                                    <mat-form-field     appearance="outline"  class="large-width">
                                        <mat-label>Adresse 1</mat-label>
                                        <input [disabled]="disabled" matInput name="Tiers_Adresse" [(ngModel)]="tiersEntiteFacturation.Tiers_Adresse" #Tiers_Adresse="ngModel" placeholder="Adresse 1" >
                                    </mat-form-field>
                                    <!-- Adresse 2 -->
                                    <mat-form-field     appearance="outline"  class="large-width">
                                        <input [disabled]="disabled"  matInput name="Tiers_Complement" [(ngModel)]="tiersEntiteFacturation.Tiers_Complement" #Tiers_Complement="ngModel" placeholder="Adresse 2" >
                                    </mat-form-field>
                                    <!-- Code postal -->
                                    <mat-form-field     appearance="outline"  class="petit-width">
                                        <mat-label>Code postal</mat-label>
                                        <input [disabled]="disabled" matInput name="Tiers_CP" [(ngModel)]="tiersEntiteFacturation.Tiers_CP" #Tiers_CP="ngModel" placeholder="Code postal" >
                                    </mat-form-field>
                                    <span>
                                        <!-- Ville -->
                                        <mat-form-field     appearance="outline"  class="moyenne-width margin-right-10">
                                            <mat-label>Ville</mat-label>
                                            <input [disabled]="disabled" matInput name="Tiers_Ville" [(ngModel)]="tiersEntiteFacturation.Tiers_Ville" #Tiers_Ville="ngModel" placeholder="Ville" >
                                        </mat-form-field>
                                        <!-- Pays -->
                                        <mat-form-field     appearance="outline"  class="moyenne-width">
                                            <mat-label>Pays</mat-label>
                                            <input [disabled]="disabled" matInput name="Tiers_Pays" [(ngModel)]="tiersEntiteFacturation.Tiers_Pays" #Tiers_Pays="ngModel" placeholder="Pays" >
                                        </mat-form-field>
                                        <mat-checkbox [(ngModel)]="showPaysInPrint" name="show_Informations_In_Print">Ne pas faire apparaître sur le pays</mat-checkbox>
                                    </span>

                                    <!-- N° Client -->
                                    <mat-form-field     appearance="outline"  class="petit-width">
                                        <mat-label>N° Client</mat-label>
                                        <input [disabled]="true" matInput name="Tiers_code" [(ngModel)]="tiersEntiteFacturation.Tiers_code" #Tiers_code="ngModel" placeholder="N° Client" >
                                    </mat-form-field>
                                    <!-- N° de TVA Intracommunautaire -->
                                    <span>
                                        <mat-form-field     appearance="outline"  class="large-width">
                                            <mat-label>N° de TVA Intracommunautaire</mat-label>
                                            <input [disabled]="disabled" matInput name="Tiers_TVA" [(ngModel)]="tiersEntiteFacturation.Tiers_TVA" #Tiers_TVA="ngModel" placeholder="N° de TVA Intracommunautaire" >
                                        </mat-form-field>
                                        <mat-checkbox [(ngModel)]="showTVAInPrint" name="show_Informations_In_Print">Ne pas faire apparaître sur le devis</mat-checkbox>
                                    </span>
                                    <!-- Email -->
                                    <mat-form-field     appearance="outline"  class="large-width">
                                        <mat-label>Email</mat-label>
                                        <input [disabled]="disabled" matInput name="Tiers_MailPro" [(ngModel)]="tiersEntiteFacturation.Tiers_MailPro" #Tiers_MailPro="ngModel" placeholder="Email" >
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </form>
            </mat-tab>
            <!-------------------- Détails document ------------>
            <mat-tab [label]="'Détails ' + nomFenetre" [disabled]="mode == 'ordinaire'?  (typeTrs == '1' && Doc_Type != 'AVC') : false">
                <mat-card >
                    <mat-card-content>
                        <app-avt-listes
                            #documentDComponen
                            [listBtn]="listBtnDocumentD"
                            (btnTable)="clickBtnHeat($event)"
                            [showFilter]="false"
                            [heightTable]="'400'"
                            [dataSourceBrut]="[]"
                            [displayedColumnsBrut]="columnsNewDocument"
                            (outputAction)="outputActionNewDocument($event)">
                        </app-avt-listes>
                    </mat-card-content>
                </mat-card>
            </mat-tab>
            <!-------------------- Informations « Bas de page » ------------>
            <mat-tab [label]="'Informations « Bas de page » ' + nomFenetre" [disabled]="mode == 'ordinaire'?  (typeTrs == '1') : false">
                <div class="displayFlex">
                    <mat-card style="display: none;" class="tab-Montants-suplementaire">
                        <h4>Montants supplémentaires</h4>
                        <app-avt-listes
                            [showFilter]="false"
                            #listeMontantsSupplementairesComponen
                            [listBtn]="listBtnListeArticle"
                            (btnTable)="clickBtnHeatMontantsSupplementaires($event)"
                            [heightTable]="'300'"
                            [dataSourceBrut]="[]"
                            [displayedColumnsBrut]="columnsListeMontantsSupplementaires">
                        </app-avt-listes>
                    </mat-card>
                    <mat-card class="Informations-bas-pages">
                        <h4>Informations bas de pages</h4>
                        <app-editor [id]="'editot-text1'" *ngIf="showEditorInfoBasPage" #editorInfoBasPage [config]="configInfoBasPage"></app-editor>
                        <!-- <angular-editor
                            [config]="editorConfig"
                            placeholder=" "
                            name="azerty"
                            [(ngModel)]="document.Doc_Param5">
                        </angular-editor> -->


                    </mat-card>
                </div>


            </mat-tab>
            <!-------------------- Suivi ------------>
            <mat-tab [label]="'Suivi ' + nomFenetre" [disabled]="mode == 'ordinaire'?  typeTrs == '1' : false">
                <div class="displayFlex">
                    <mat-card [ngClass]=
                    "{
                    'suivi-left-facture':fenetre == '1',
                    'suivi-left':fenetre != '1'
                    }">
                        <div class="suivi-left-1">
                            <table>
                                <tr>
                                    <td>
                                        <mat-checkbox [disabled]="disabled" name="showDoc_ExoDate" [(ngModel)]="showDoc_ExoDate">{{nomFenetre}} émise le</mat-checkbox>
                                    </td>
                                    <td>
                                        <mat-form-field  style="width: 130px;"   appearance="outline"  *ngIf="showDoc_ExoDate">
                                            <input [disabled]="disabled" matInput name="Doc_ExoDate" [(ngModel)]="document.Doc_ExoDate" #Doc_ExoDate="ngModel"  [matDatepicker]="picker5">
                                            <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                                            <mat-datepicker #picker5></mat-datepicker>
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <ng-container *ngIf="fenetre == '1'">
                                    <tr>
                                        <td>
                                            <mat-checkbox [disabled]="disabled" name="showDoc_DateP" [(ngModel)]="showDoc_DateP">{{nomFenetre}} réglée le</mat-checkbox>
                                        </td>
                                        <td>
                                            <mat-form-field  style="width: 130px;"   appearance="outline"  *ngIf="showDoc_DateP">
                                                <input [disabled]="disabled" matInput name="Doc_DateP" [(ngModel)]="document.Doc_DateP" #Doc_DateP="ngModel"  [matDatepicker]="picker9">
                                                <mat-datepicker-toggle matSuffix [for]="picker9"></mat-datepicker-toggle>
                                                <mat-datepicker #picker9></mat-datepicker>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <mat-checkbox [disabled]="disabled" name="showDoc_DateRelance1" [(ngModel)]="showDoc_DateRelance1">1ère relance</mat-checkbox>
                                        </td>
                                        <td>
                                            <mat-form-field style="width: 130px;"    appearance="outline"  *ngIf="showDoc_DateRelance1">
                                                <input [disabled]="disabled" matInput name="Doc_DateRelance1" [(ngModel)]="document.Doc_DateRelance1" #Doc_DateRelance1="ngModel"  [matDatepicker]="picker8">
                                                <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
                                                <mat-datepicker #picker8></mat-datepicker>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <mat-checkbox [disabled]="disabled" name="showDoc_DateRelance2" [(ngModel)]="showDoc_DateRelance2">2ème relance</mat-checkbox>
                                        </td>
                                        <td>
                                            <mat-form-field  style="width: 130px;"   appearance="outline"  *ngIf="showDoc_DateRelance2">
                                                <input [disabled]="disabled" matInput name="Doc_DateRelance2" [(ngModel)]="document.Doc_DateRelance2" #Doc_DateRelance2="ngModel"  [matDatepicker]="picker6">
                                                <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                                                <mat-datepicker #picker6></mat-datepicker>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <mat-checkbox [disabled]="disabled" name="showDoc_DateRelance3" [(ngModel)]="showDoc_DateRelance3">3ème relance</mat-checkbox>
                                        </td>
                                        <td>
                                            <mat-form-field  style="width: 130px;"   appearance="outline"  *ngIf="showDoc_DateRelance3">
                                                <input [disabled]="disabled" matInput name="Doc_DateRelance3" [(ngModel)]="document.Doc_DateRelance3" #Doc_DateRelance3="ngModel"  [matDatepicker]="picker7">
                                                <mat-datepicker-toggle matSuffix [for]="picker7"></mat-datepicker-toggle>
                                                <mat-datepicker #picker7></mat-datepicker>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-container *ngIf="fenetre != '1'">
                                    <tr>
                                        <td>
                                            <mat-checkbox [disabled]="disabled" name="show_date_point" [(ngModel)]="showDateRelance">{{nomFenetre}} sans réponse-en attente</mat-checkbox>
                                        </td>
                                        <td>
                                            <mat-form-field style="width: 130px;"    appearance="outline"  *ngIf="showDateRelance">
                                                <input [disabled]="disabled" matInput name="Doc_DateRelance" [(ngModel)]="document.Doc_DateRelance" #Doc_DateRelance="ngModel"  [matDatepicker]="picker0">
                                                <mat-datepicker-toggle matSuffix [for]="picker0"></mat-datepicker-toggle>
                                                <mat-datepicker #picker0></mat-datepicker>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <mat-checkbox [disabled]="disabled" name="show_Date_Validation" [(ngModel)]="showDoc_ExoDateFin">Date {{nomFenetre}} accepté</mat-checkbox>
                                        </td>
                                        <td>
                                            <mat-form-field  style="width: 130px;"   appearance="outline"  *ngIf="showDoc_ExoDateFin">
                                                <input [disabled]="disabled" matInput name="Doc_ExoDateFin" [(ngModel)]="document.Doc_ExoDateFin" #Doc_ExoDateFin="ngModel"  [matDatepicker]="picker3">
                                                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                                <mat-datepicker #picker3></mat-datepicker>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <mat-checkbox [disabled]="disabled" name="show_Doc_DateAvisExped" [(ngModel)]="showDoc_DateAvisExped">Date {{nomFenetre}} refusé</mat-checkbox>
                                        </td>
                                        <td>
                                            <mat-form-field style="width: 130px;"    appearance="outline"  *ngIf="showDoc_DateAvisExped">
                                                <input [disabled]="disabled" matInput name="Doc_DateAvisExped" [(ngModel)]="document.Doc_DateAvisExped" #Doc_DateAvisExped="ngModel"  [matDatepicker]="picker4">
                                                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                                <mat-datepicker #picker4></mat-datepicker>
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                </ng-container>
                            </table>
                        </div>
                        <div class="suivi-left-2" *ngIf="fenetre == '1'">
                            <!-- <mat-form-field     appearance="outline" >
                                <mat-label>Mode de facturation</mat-label>
                                <mat-select [disabled]="disabled" name="Mode_Fac" [(ngModel)]="document.ModeFac_Code" #ModeReghode="ngModel" placeholder="Mode de facturation" >
                                    <mat-option *ngFor="let modeFac of listeModeFacturation" [value]="modeFac.DiverSys_Index">
                                    {{modeFac.DiverSys_Titre}}</mat-option>
                                </mat-select>
                            </mat-form-field> -->
                            <mat-form-field     appearance="outline" >
                                <mat-label>Mode de règlement</mat-label>
                                <mat-select [disabled]="disabled" name="Doc_ModeReg" [(ngModel)]="document.Doc_ModeReg" #Doc_ModeReg="ngModel" placeholder="Mode de règlement" >
                                    <mat-option *ngFor="let ModePaiement of listeModePaiement" [value]="ModePaiement.DiverSys_Index">
                                    {{ModePaiement.DiverSys_Titre}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <!-- <mat-checkbox [disabled]="disabled" name="show_Gestion_Ecriture_Comtable" [(ngModel)]="showGestionEcritureComtable">Générer l’écriture en comptabilité</mat-checkbox>

                            <mat-radio-group [disabled]="disabled" *ngIf="showGestionEcritureComtable" name="show_Gestion_Ecriture_Comtable2"  [(ngModel)]="gestionEcritureComtable">
                                <mat-radio-button  value="0">Vente de marchandises</mat-radio-button>
                                <mat-radio-button  value="1">Prestations de services</mat-radio-button>
                                <mat-radio-button  value="2">Autres</mat-radio-button>
                            </mat-radio-group> -->
                        </div>
                    </mat-card>
                    <mat-card class="suivi-right">
                        <h4>Commentaires (informations n’apparaissant pas sur le document)</h4>
                        <app-editor  [id]="'editot-text2'" *ngIf="showEditorCommentaires" #editorCommentaires [config]="configCommentaires"></app-editor>
                        <!-- <angular-editor
                            [config]="editorConfig"
                            placeholder=" "
                            name="qwerty"
                            [(ngModel)]="document.Com">
                        </angular-editor> -->
                    </mat-card>
                </div>
            </mat-tab>
            <!-------------------- fin Suivi ------------>

        </mat-tab-group>

    </mat-card-content>
</mat-card>